import "./Separator.scss";

type Orientation = "horizontal" | "vertical";

interface Props {
  orientation?: Orientation;
  className?: string;
}
export const Separator = ({
  orientation = "horizontal",
  className = "",
}: Props) => {
  return (
    <div
      className={`separator${
        orientation === "vertical" ? "--vertical" : ""
      } ${className}`}
    />
  );
};
